// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Module-based unsaved changes tracking
  // Each module can have its own unsaved state
  modules: {
    // Example modules:
    // serviceTypesForm: {
    //   hasUnsavedChanges: false,
    //   shouldShowUnsavedModal: false,
    //   lastSavedData: null,
    //   currentData: null,
    //   pendingAction: null
    // }
  }
};

const unsavedSlice = createSlice({
  name: 'unsaved',
  initialState,
  reducers: {
    /**
     * Set unsaved changes state for a specific module
     * Automatically initializes module if it doesn't exist
     */
    setUnsavedChanges: (state, action) => {
      const {
        moduleName,
        hasUnsavedChanges,
        currentData = null
      } = action.payload;

      if (!state.modules[moduleName]) {
        state.modules[moduleName] = {
          hasUnsavedChanges: false,
          shouldShowUnsavedModal: false,
          lastSavedData: null,
          currentData: null,
          pendingAction: null
        };
      }

      state.modules[moduleName].hasUnsavedChanges = hasUnsavedChanges;

      if (currentData !== null) {
        state.modules[moduleName].currentData = currentData;
      }
    },

    /**
     * Show unsaved changes modal for a specific module
     */
    showUnsavedModal: (state, action) => {
      const { moduleName, pendingAction = null } = action.payload;

      if (state.modules[moduleName]) {
        state.modules[moduleName].shouldShowUnsavedModal = true;
        state.modules[moduleName].pendingAction = pendingAction;
      }
    },

    /**
     * Hide unsaved changes modal for a specific module
     */
    hideUnsavedModal: (state, action) => {
      const { moduleName } = action.payload;

      if (state.modules[moduleName]) {
        state.modules[moduleName].shouldShowUnsavedModal = false;
        state.modules[moduleName].pendingAction = null;
      }
    },

    /**
     * Save data for a module (marks as saved)
     */
    saveModuleData: (state, action) => {
      const { moduleName, savedData } = action.payload;

      if (state.modules[moduleName]) {
        state.modules[moduleName].hasUnsavedChanges = false;
        state.modules[moduleName].shouldShowUnsavedModal = false;
        state.modules[moduleName].lastSavedData = savedData;
        state.modules[moduleName].currentData = savedData;
        state.modules[moduleName].pendingAction = null;
      }
    },

    /**
     * Discard changes for a module (revert to last saved)
     */
    discardModuleChanges: (state, action) => {
      const { moduleName } = action.payload;

      if (state.modules[moduleName]) {
        state.modules[moduleName].hasUnsavedChanges = false;
        state.modules[moduleName].shouldShowUnsavedModal = false;
        state.modules[moduleName].currentData =
          state.modules[moduleName].lastSavedData;
        state.modules[moduleName].pendingAction = null;
      }
    },

    /**
     * Clear a module's unsaved changes state
     */
    clearModuleUnsavedState: (state, action) => {
      const { moduleName } = action.payload;
      delete state.modules[moduleName];
    },

    /**
     * Clear all unsaved changes state
     */
    clearAllUnsavedChanges: (state) => {
      state.modules = {};
    },

    /**
     * Update current data for a module without changing unsaved status
     */
    updateModuleCurrentData: (state, action) => {
      const { moduleName, currentData } = action.payload;

      if (!state.modules[moduleName]) {
        state.modules[moduleName] = {
          hasUnsavedChanges: false,
          shouldShowUnsavedModal: false,
          lastSavedData: null,
          currentData: null,
          pendingAction: null
        };
      }

      state.modules[moduleName].currentData = currentData;
    },

    /**
     * Set pending action for a module
     */
    setPendingAction: (state, action) => {
      const { moduleName, pendingAction } = action.payload;

      if (state.modules[moduleName]) {
        state.modules[moduleName].pendingAction = pendingAction;
      }
    }
  }
});

const { actions, reducer } = unsavedSlice;

export const {
  setUnsavedChanges,
  showUnsavedModal,
  hideUnsavedModal,
  saveModuleData,
  discardModuleChanges,
  clearModuleUnsavedState,
  clearAllUnsavedChanges,
  updateModuleCurrentData,
  setPendingAction
} = actions;

export default reducer;
